module.exports = __webpack_public_path__ + "static/paprica-3-dc7245aafb6ee1e52c6851187750baa3.png";